import Vue from "vue";
import {
  Alert,
  Button,
  Form,
  FormItem,
  Input,
  Table,
  TableColumn,
  Drawer,
  Switch,
  Select,
  Option,
  Message,
  MessageBox,
  Notification,
  Row,
  Col,
  Dialog,
  Loading,
  Checkbox,
  Tabs,
  TabPane,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Upload,
  DatePicker,
  Pagination,
  Autocomplete,
  Card,
  Tag,
  Collapse,
  CollapseItem,
  InputNumber,
  Rate,
  Image,
} from "element-ui";
import lang from "element-ui/lib/locale/lang/ru-RU";
import locale from "element-ui/lib/locale";

locale.use(lang);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Button);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Table);
Vue.use(Rate);
Vue.use(TableColumn);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Upload);
Vue.use(DatePicker);
Vue.use(Pagination);
Vue.use(Autocomplete);
Vue.use(Card);
Vue.use(InputNumber);
Vue.use(Image);
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$notify = Notification;
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
